import { useAttachFiles } from "@ext/agent/components/hooks/useAttachFiles";
import { useChatComposerDisabled } from "@ext/agent/components/hooks/useChatComposerDisabled";
import { useFileDrop } from "@ext/agent/components/hooks/useFileDrop";
import useChatStore from "@ext/agent/components/store/ChatStore";
import { getAgentMode } from "@ext/agent/core/agentMode";
import { type ClipboardEvent, useCallback } from "react";
import { useShallow } from "zustand/react/shallow";

export const useChatPanelFiles = () => {
	const { attachments, onAttachmentsChange } = useChatStore(
		useShallow((s) => ({ attachments: s.attachments, onAttachmentsChange: s.onAttachmentsChange })),
	);
	const attachDisabled = useChatComposerDisabled() || getAgentMode() !== "full";
	const attach = useAttachFiles(attachments, onAttachmentsChange);
	const { attachFiles } = attach;
	const { isDragging, dropProps } = useFileDrop(attachFiles, attachDisabled);

	const onPaste = useCallback(
		(e: ClipboardEvent) => {
			const files = Array.from(e.clipboardData.files);
			const isOfficeSelection = e.clipboardData.getData("text/plain") && e.clipboardData.getData("text/html");
			if (attachDisabled || !files.length || isOfficeSelection) return;
			e.preventDefault();
			attachFiles(files);
		},
		[attachFiles, attachDisabled],
	);

	return { attach, isDragging, panelProps: { ...dropProps, onPaste } };
};
